import "./ContactRequestQuote.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetails from "./sections/ContactDetails";
import QuoteForm from "./sections/QuoteForm";
import CoverageMap from "./sections/CoverageMap";
import WhyBmf from "./sections/WhyBmf";
import Footer from "@/reusable_sections/Footer";
export default function ContactRequestQuotePage() {
  return <div>
      <Header />
      <ContactDetails />
      <QuoteForm />
      <CoverageMap />
      <WhyBmf />
      <Footer />
    </div>;
}